import * as React from 'react';
import { useEffect, useState } from 'react';
import { Communicator } from '../../tools/Communication';
import i18n from '@/utils/i18n';
import { LayoutStoreInstance } from '../../LayoutStore';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { EditSection } from '../../components/Layout';
import { DEFAULT_CONTAINER_TYPE_ICON } from '@/utils/imageUrl';
import ClassicLoadingSpinner from '../../components/LoadingSpinner/ClassicLoadingSpinner';
import { ContainerCollection, ContainerCollectionEntry } from './model';

export default function ContainerCollectionLocationsView({
  match: {
    params: { id },
  },
}: {
  match: { params: { id: string } };
}) {
  const [collection, setCollection] = useState<ContainerCollection>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const promises = [
      Communicator.Get(`api/3/ContainerCollection/Get/${id}`, {})
        .then(async (response) => {
          const body = await response.json();
          if (response.status === 200) {
            setCollection(body);
          } else {
            LayoutStoreInstance.setError('Failed to load collection: ' + body);
          }
        })
        .catch((error) => {
          LayoutStoreInstance.setError('Failed to load collection: ' + error);
        }),
    ];
    Promise.all(promises).then(() => setIsLoading(false));
  }, []);

  if (isLoading || collection == null) {
    return <ClassicLoadingSpinner />;
  }

  return (
    <EditSection title={i18n.t('Common:containerCollection')}>
      <div className="input-group mb-3">
        <h4>
          <b>{`${i18n.t('ContainerCollection:location')}:`}</b>
          <a
            href={`/container-collection-by-location?location=${collection.location}`}
          >
            <span> {collection.location}</span>
          </a>
        </h4>
      </div>
      <div className="input-group mb-3">
        <h4>
          <b>{`${i18n.t('ContainerCollection:containerCount')}:`}</b>{' '}
          {collection.count}
        </h4>
      </div>
      <DataTable
        value={collection.containers}
        dataKey="id"
        responsiveLayout="scroll"
        loading={isLoading}
        className="p-datatable-striped"
        style={{ width: '100%', overflowX: 'scroll' }}
      >
        <Column
          body={(c: ContainerCollectionEntry) =>
            renderCell(`/container/${c.id}`, true, i18n.t('Common:view'))
          }
          header={i18n.t('Common:view')}
        />
        <Column
          headerStyle={{ width: '100' }}
          body={(c: ContainerCollectionEntry) => renderCell(c.name)}
          header={i18n.t('Common:name')}
        />
        <Column
          headerStyle={{ width: '100' }}
          body={(c: ContainerCollectionEntry) => renderCell(c.typeName)}
          header={i18n.t('ContainerCollection:typeName')}
        />
        <Column
          headerStyle={{ width: '100' }}
          body={(c: ContainerCollectionEntry) => (
            <img
              style={{ float: 'left', width: '3.2rem', height: '3rem' }}
              src={
                c.typeImageUrl || c.typeIconUrl || DEFAULT_CONTAINER_TYPE_ICON
              }
              alt={c.typeName || '-'}
            />
          )}
          header={i18n.t('ContainerCollection:typeIcon')}
        />
      </DataTable>
    </EditSection>
  );
}

function renderCell(content: any, displayAsAnchor = false, alias = '') {
  if (displayAsAnchor) {
    return (
      <a href={content}>
        <span>{alias}</span>
      </a>
    );
  }
  return (
    <div>
      <span>{content}</span>
    </div>
  );
}
